export function StarStruckEmoji() {
  return (
    <img
      src="/assets/images/star-struck.png"
      alt="star struck emoji"
      className="w-5 h-5"
    />
  );
}

export function SlightlyFrowningFaceEmoji() {
  return (
    <img
      src="/assets/images/slightly-frowning-face.png"
      alt="slightly frowning face emoji"
      className="w-5 h-5"
    />
  );
}

export function NeutralFaceEmoji() {
  return (
    <img
      src="/assets/images/neutral-face.png"
      alt="neutral face emoji"
      className="w-5 h-5"
    />
  );
}

export function BlushFaceEmoji() {
  return (
    <img
      src="/assets/images/blush-face.png"
      alt="blush face emoji"
      className="w-5 h-5"
    />
  );
}
